/* eslint-disable tss-unused-classes/unused-classes -- classes are used via returned object from makeStyles hook */
import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { COLORS } from '@/styles/tokens/colors';
import { FONT_WEIGHTS } from '@/styles/tokens/fonts';
import { BALANCE_SHEET_COLUMN_GAP_WIDTH, getBalanceSheetPadding } from '../../BalanceSheetTable.layout';
import { BalanceSheetCellPosition, BalanceSheetDensity } from '../../BalanceSheetTable.types';

/**
 * Presentation context colors (neutral grayscale for white-labeling)
 */
const PRESENTATION_COLORS = {
  textPrimary: COLORS.NEUTRAL_GRAY[900],
  border: COLORS.NEUTRAL_GRAY[300]
};

/**
 * App context colors (navy theme)
 */
const APP_COLORS = {
  textPrimary: COLORS.TEXT.PRIMARY,
  border: COLORS.NAVY[100]
};
export interface BalanceSheetHeaderGroupStyleProps {
  density: BalanceSheetDensity;
  alignment: 'left' | 'right';
  isPresentation: boolean;
  cellPosition: BalanceSheetCellPosition;
  minWidth?: number;
  maxWidth?: number;
}
export const useBalanceSheetHeaderGroupStyles = makeStyles<BalanceSheetHeaderGroupStyleProps>()((_theme: Theme, props) => {
  const {
    alignment,
    density,
    isPresentation,
    cellPosition
  } = props;
  const colors = isPresentation ? PRESENTATION_COLORS : APP_COLORS;
  const padding = getBalanceSheetPadding(density, cellPosition);
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: alignment === 'right' ? 'flex-end' : 'flex-start',
      justifyContent: 'flex-end',
      // Grid sizes this header group via the column track; minWidth: 0
      // allows content to shrink below its intrinsic size.
      minWidth: 0,
      ...padding,
      borderBottom: `2px solid ${colors.border}`
    },
    text: {
      fontFamily: 'Inter, sans-serif',
      fontSize: '12px',
      lineHeight: '16px',
      fontWeight: FONT_WEIGHTS.bold,
      // 600 (semibold)
      color: colors.textPrimary,
      textTransform: 'uppercase',
      textAlign: alignment
    },
    columnGap: {
      width: BALANCE_SHEET_COLUMN_GAP_WIDTH,
      flexShrink: 0,
      alignSelf: 'stretch'
    }
  };
});